<template>
  <div class="school-hq-selector SchoolHQSelector">
    <b-autocomplete
      v-model="searchText"
      openOnFocus
      clearable
      rounded
      iconRight="chevron-down"
      :class="[
        'SchoolHQSelector__AutoComplete',
        'min-w-[300px]',
        '&>div>.input]:min-w-[350px]',
        '[&>div>.input]:placeholder-lighter-grey-3',
        '[&>.dropdown-menu>.dropdown-content] [&>.dropdown-menu]:bg-transparent [&>.dropdown-menu>.dropdown-content]:bg-white-grey [&>.dropdown-menu>.dropdown-content]:shadow-context-menu',
        '[&>.dropdown-menu>.dropdown-content>a]:hover:bg-white-grey [&>.dropdown-menu>.dropdown-content>a]:p-0px',
      ]"
      :loading="loading"
      :data="searchResult"
      :placeholder="onSelectSchool ? $get(value, 'name', $t('select')) : $get(schoolProfile, 'name', $t('select'))"
      @focus="focusToSelectedSchool"
      @input="debounceSearch()"
    >
      <template slot-scope="props">
        <SchoolHQSelectItem
          :level="0"
          :school="props.option"
          :searchText="searchText"
          :onSelect="onSelect"
        ></SchoolHQSelectItem>
      </template>
      <template #empty>
        <div class="no-result">
          <p>No results found</p>
        </div>
      </template>
    </b-autocomplete>
  </div>
</template>

<script>
import { debounce, cloneDeep, get } from 'lodash'
import SchoolHQSelectItem from '~/components/v2/Inputs/SchoolHQSelectItem.vue'

export default {
  name: 'SchoolHQSelect',

  components: {
    SchoolHQSelectItem,
  },

  props: {
    isFirstLevel: {
      type: Boolean,
      default: true,
    },
    onSelectSchool: {
      type: Function,
      default: null,
    },
    value: {
      type: Object,
      default: () => null,
    },
    schoolTreeHasChildren: {
      type: Array,
      default: () => [],
    },
    schoolProfile: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: false,
      searchText: '',
      searchResult: [],
      showFullOptions: true,
      stateSchoolTreeHasChildren: cloneDeep(this.schoolTreeHasChildren),
    }
  },

  methods: {
    debounceSearch: debounce(function () {
      this.loading = true
      const result = this.search(this.stateSchoolTreeHasChildren)
      this.searchResult = result
      this.loading = false
    }, 500),
    search(parentSchool, parent) {
      parentSchool.forEach((school) => {
        this.$set(school, 'hidden', true)
        this.$set(school, 'parent', parent)

        const parentNode = school

        const valid = this.searchText ? school.name.toLowerCase().includes(this.searchText.toLowerCase()) : true
        if (school.children && school.children.length > 0) {
          this.search(school.children, parentNode)
        }
        if (valid) {
          school.hidden = false
          this.$set(school, 'hidden', false)
          if (school.parent) {
            this.$set(school.parent, 'hidden', false)
          }
        }
      })
      return parentSchool
    },
    async onSelect(school) {
      if (this.onSelectSchool) {
        await this.onSelectSchool(cloneDeep(school))
      }
    },
    focusToSelectedSchool() {
      const dropdownContent = document.getElementsByClassName('dropdown-content')[0]
      setTimeout(() => {
        const position = get(dropdownContent.getElementsByClassName('selected-school')[0], 'offsetTop')
        if (position) {
          const scroll = position > dropdownContent.clientHeight ? position - dropdownContent.clientHeight / 2 : 0
          dropdownContent.scrollTo({
            top: scroll,
          })
        }
      }, 500)
    },
    init() {
      this.searchResult = cloneDeep(this.schoolTreeHasChildren)
    },
  },

  watch: {
    schoolTreeHasChildren() {
      this.init()
    },
  },

  created() {
    this.init()
  },
}
</script>
